// extracted by mini-css-extract-plugin
export default {"browse":"qmpj2","opened":"FY0w6","menu":"mhSku","inverted":"t69l4"};